<template>
  <div class="portlet">
    <div class="portlet-head">
      <h3><i class="fas fa-file-signature"></i> Wydania materiałów na budowy</h3>
      <div>
        <button class="btn btn-outline-primary" style="display: none">
          <b-spinner small></b-spinner>
          <i class="fas fa-file-export"></i> Exportuj raport
        </button>
        <button class="btn btn-outline-secondary" @click="handleSearch">
          <i class="fas fa-sync"></i> Odśwież
        </button>
        <b-dropdown right variant="outline-primary" class="month">
          <template v-slot:button-content>
            <i class="fas fa-plus"></i> Dodaj zdarzenie...
          </template>
          <b-dropdown-item-button
            variant="outline-primary"
            @click="showModalMaterials('wz')"
            >Wydanie materiałów na budowe</b-dropdown-item-button
          >
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item-button
            variant="outline-primary"
            @click="showModalMaterials('zw')"
          >
            Zwrot materiałów z budowy
          </b-dropdown-item-button>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item-button
            class="outline-primary"
            @click="showModalMaterials('pmb')"
            >Przyjęcie materiałów z budowy</b-dropdown-item-button
          >
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item-button
              class="outline-primary"
              @click="showModalMaterials('sp')"
          >Sprzedaż materiałów</b-dropdown-item-button
          >
        </b-dropdown>


      </div>
    </div>
    <div class="portlet-body">
      <div class="searchpanel">
        <b-form inline>
          <DatepickerWithDropdown
            class="datepicker"
            :selected="this.selectedRange"
            @input="range"
            :range="search.issue_date"
          />
          <b-form-group
              label-class="mr-3"
              class="searchpanel-item"
              label-for="categories"
          >

          <multiselect
              class="mb-3"
              v-model="filteredTypes"
              placeholder="Filtruj po zdarzeniach"
              label="name"
              track-by="id"
              :options="typeChoice()"
              :show-labels="false"
              :group-select="false"
              :multiple="true"
              :max="8"
              style="min-width: 300px"
          ></multiselect>
          </b-form-group>
          <b-form-group
            label-class="mr-3"
            class="searchpanel-item"
            label-for="categories"
          >

            <multiselect
              class="mb-3"
              v-model="selectedConstructions"
              placeholder="Filtruj po budowach"
              label="name"
              track-by="id"
              :options="constructions"
              :show-labels="false"
              :group-select="false"
              :multiple="true"
              :max="8"
              style="min-width: 300px"
            ></multiselect>
          </b-form-group>
        </b-form>
      </div>

      <b-table
        class="table table-list table-mobilepro bills-table"
        ref="issuance_table"
        :fields="fields"
        :busy.sync="isBusy"
        :items="filteredIssuances"
        stacked="lg"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        sort-icon-left
        empty-text="Brak Wydań"
        show-empty
      >
        <template v-slot:table-busy>
          <TableSpiner />
        </template>
        <template v-slot:empty="{ emptyText }">
          <div class="empty">
            <i class="empty-state fas fa-file-signature"></i>
            <span class="empty-search">{{ emptyText }}</span>
          </div>
        </template>
        <template v-slot:cell(issue_date)="data">
          <a style="cursor: pointer" @click="showDetails(data.item)">{{
            data.item.issue_date | date
          }}</a>
        </template>
        <template v-slot:cell(type)="data">
          <b-badge :variant="badgeType((badgeColor = data.item.type))">{{
            types[data.item.type]
          }}</b-badge>
        </template>
        <template v-slot:cell(invoice)="">
          -
        </template>
        <template v-slot:cell(construction)="data">
          <div v-if="!data.item.construction">
          <span> -
            </span>
          </div>
          <div v-else>

            <router-link
                :to="'/construction/' + data.item.construction.id"
                class="badge badge-light"
                style="font-size: 14px"
            >{{ data.item.construction.name }}</router-link
            >

          </div>
        </template>
        <template v-slot:cell(cost)="data">
          {{ data.item.cost.toFixed(2) }}
          <small>{{getMainBaseCurrency}}</small>
        </template>
        <template v-slot:cell(options)="data">
          <div class="text-right text-lg-center">
            <b-dropdown no-caret right variant="light" class="btn-rounded">
              <template v-slot:button-content>
                <i class="fas fa-ellipsis-v"></i>
              </template>
              <b-dropdown-item-button @click="showDetails(data.item)"
                >Szczegóły zdarzenia</b-dropdown-item-button
              >
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item-button
                class="danger"
                @click="confirmRemove(data.item)"
              >
                <i class="fas fa-trash-alt"></i> Usuń
              </b-dropdown-item-button>
            </b-dropdown>
          </div>
        </template>
      </b-table>
    </div>
    <ModalTakeMaterials
      :title="title"
      :btnSubmitText="submitText"
      :issuance="true"
      :type="selectedType"
      @submit="submitIssuance"
    />
    <ModalMaterialsEvent :event="selectedEvent" />
    <ModalCreateInvoice :invoiceItem="invoiceItem" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { WarehouseEvents } from "@/services/warehouse.service";
import {formatDateTime} from "@/services/helpers";
import DatepickerWithDropdown from "@/components/DatepickerWithDropdown";
import TableSpiner from "@/components/TableSpiner";
import ModalTakeMaterials from "@/components/warehouse/ModalTakeMaterials";
import ModalMaterialsEvent from "@/components/warehouse/ModalMaterialsEvent";
import ModalCreateInvoice from "@/components/warehouse/ModalCreateInvoice";
import dayjs from "dayjs";

export default {
  name: "TheIssuance",
  components: {
    DatepickerWithDropdown,
    TableSpiner,
    ModalTakeMaterials,
    ModalMaterialsEvent,
    ModalCreateInvoice,
  },
  data() {
    return {
      title: "",
      submitText: "",
      sortBy: "issue_date",
      selectedEvent: {},
      selectedType: "",
      sortDesc: true,
      isBusy: false,
      fields: [
        { key: "issue_date", label: "Data zdarzenia", sortable: true },
        { key: "type", label: "Rodzaj zdarzenia", sortable: true },
        { key: "construction", label: "Budowa", class: "longName" },
        { key: "invoice", label: "Faktura", class: "text-center" },
        {
          key: "quantity",
          label: "Ilość",
          class: "text-right",
        },
        { key: "cost", label: "Wartość", class: "text-right" },
        { key: "options", label: "Opcje", class: "text-center" },
      ],
      filteredTypes: [],
      selectedConstructions: [],
      invoiceItem: {},
    };
  },
  filters: {
    date(value) {
      return formatDateTime(value, "YYYY-MM-DD HH:mm");
    }
  },
  computed: {
    ...mapGetters("company", ["getMainBaseCurrency"]),
    ...mapGetters("issuances", [
      "types",
      "search",
      "selectedRange",
      "issuances",
      "constructions",
      "search",
    ]),


    filteredIssuances() {
      let filteredIssuances = [];
      if (this.selectedConstructions.length > 0) {
          this.issuances.forEach((issuance) => {
            this.selectedConstructions.find(({ id }) => {
              if (issuance.construction && issuance.construction.id && (id === issuance.construction.id)) {
                filteredIssuances.push(issuance);
              }
            });
          });
      }
      if (this.filteredTypes.length > 0) {
        if (filteredIssuances.length > 0) {
          filteredIssuances = filteredIssuances.filter((issuance) => {
            return this.filteredTypes.find(({ id }) => {
              return issuance.type && (id === issuance.type);
            });
          });
        } else {
          filteredIssuances = this.issuances.filter((issuance) => {
            return this.filteredTypes.find(({ id }) => {
              return issuance.type && (id === issuance.type);
            });
          });
        }
      }
      if (filteredIssuances.length > 0) {
        return filteredIssuances;
      } else {
        return this.issuances;
      }
    }
  },

  methods: {
    ...mapActions("issuances", ["doSearch", "remove", "create"]),
    showModalMaterials(type) {
      if (type === "zw") {
        this.title = "Zwrot wydanego towaru";
        this.submitText = "Przyjmij materiały";
        this.selectedType = "zw";
      } else if (type === "pmb") {
        this.title = "Przyjęcie towaru z budowy";
        this.submitText = "Przyjmij materiały";
        this.selectedType = "pmb";
      } else if (type === "sp") {
        this.title = "Sprzedaż towaru z magazynu";
        this.submitText = "Sprzedaj materiały";
        this.selectedType = "sp";
        this.$emit("sp");
      } else {
        this.title = "Wydanie towaru z magazynu";
        this.submitText = "Wydaj towar";
        this.selectedType = "wz";
      }
      this.$nextTick(() => {
        this.$bvModal.show("take-materials-modal");
      });
    },
    showDetails(event) {
      this.selectedEvent = event;
      this.$nextTick(() => {
        this.$bvModal.show("materialevent-modal");
      });
    },
    createInvoice(event) {
      this.selectedEvent = event;
      if (this.invoiceItem.id && event.id === this.invoiceItem.id) {
        this.$bvModal.show("createinvoice-modal");
        return;
      }
      WarehouseEvents.event(event.id)
        .then((data) => {
          this.invoiceItem = data;
        })
        .finally(() => {
          this.$bvModal.show("createinvoice-modal");
        });
    },
    confirmRemove(issuance) {
      let h = this.$createElement;
      this.$bvModal
        .msgBoxConfirm(
          [
            h("p", [
              "Czy napewno chcesz usunąć wydanie towaru dla budowy ",
              h("br"),
              h("strong", [
                issuance.construction.name,
                h("br"),
                "z dnia ",
                dayjs(issuance.issue_date).format("YYYY-MM-DD"),
              ]),
              " ?",
              h("br"),
              h("br"),
              h("small", "Stan magazynu nie ulegnie zmianie."),
            ]),
          ],
          {
            title: "Potwierdź usunięcie wydania towaru",
            okVariant: "danger",
            okTitle: "TAK",
            cancelTitle: "NIE",
          }
        )
        .then((result) => {
          if (result !== true) {
            return;
          }
          this.$Progress.start();
          this.remove(issuance.id).then(() => {
            this.$refs.issuance_table.refresh();
          });
        });
    },
    range(range, selected) {
      if (range) {
        this.$store.commit("issuances/range", {
          selected: selected,
          range: range,
        });
        this.handleSearch();
      }
    },
    handleSearch() {
      this.isBusy = true;
      this.$Progress.start();
      this.selectedConstructions = [];
      this.doSearch(this.search)
          .then(() => {
            this.isBusy = false;
          })
          .catch((e) => {
            console.log(e)
            //TODO: Handle error
          });
    },
    submitIssuance(form) {
      this.$Progress.start();
      this.create(form).then(() => {
        this.$refs.issuance_table.refresh();
        this.$nextTick(() => {
          this.$bvModal.hide("take-materials-modal");
        });
      });
    },
    badgeType() {
      if (this.badgeColor == "wz") {
        return "primary";
      } else if (this.badgeColor == "pmb") {
        return "success";
      } else if (this.badgeColor == "sp") {
        return "warning";
      } else {
        return "info";
      }
    },
    typeChoice() {
      return Object.keys(this.types).map(key => ({ id: key, name: this.types[key] }));
    },

  },
};
</script>
